export default __webpack_public_path__ + "static/proper-details-top-video-d-c457f0a2f003c2122938f343f690e921.jpg";